import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Collection } from 'src/app/models/collection';
import { SliderComponent } from '../slider/slider.component';

@Component({
  selector: 'app-slider-classic',
  templateUrl: './slider-classic.component.html',
  styleUrls: ['../slider/slider.component.scss'],
})
export class SliderClassicComponent implements OnInit {
  @Input()
  collection: Collection;

  @Input()
  preview: boolean;

  @ViewChild('slider', { static: false })
  slider: SliderComponent;

  constructor() {}

  ngOnInit(): void {}

  queryCollection() {
    this.slider.queryCollection();
  }

  showPreview(collection: Collection) {
    return collection.records.length > 0;
  }
}
